export const backupConfig = {
    "IMinimumAmountGunsForAFreeDeliveryInCertainRegions": 16,
        "INumberOfLaserGunsNotAllowedToReserveInRentalPoints": 32,
            "IFreeDeliveryFromNumberOfLaserGuns": 40,
                "freeDeliveryInterval": [
                    {
                        "start": "2023-04-01",
                        "end": "2023-04-17"
                    }
                ],
                    "discount50DeliveryInterval": [
                        {
                            "start": "2023-05-18",
                            "end": "2023-05-21"
                        }
                    ],
                        "shippingCosts": {
        "default": {
            "DPDPoint": 15,
                "DPDPoint50Discount": 7.5,
                    "DPD": 20,
                        "DPD50Discount": 10,
                            "Transforce": 30,
                                "TransforceBow": 25,
                                    "Transforce50Discount": 15
        },
        "phoenix": {
            "dpd": {
                "8": 15,
                    "16": 15,
                        "24": 15,
                            "32": 30,
                                "40": 30,
                                    "48": 30
            },
            "transforceDpd": {
                "8": 20,
                    "16": 20,
                        "24": 20,
                            "32": 25,
                                "40": 25,
                                    "48": 25,
                                        "56": 30,
                                            "64": 30
            },
            "transforce": {
                "8": 30,
                    "16": 30,
                        "24": 30,
                            "32": 50,
                                "40": 50,
                                    "48": 50,
                                        "56": 60,
                                            "64": 60,
                                                "72": 80,
                                                    "80": 80,
                                                        "88": 80,
                                                            "96": 80,
                                                                "104": 80
            }
        }
    },
    "standardPromotion": {
        "phoenix": {
            "transforce": {
                "deliveryPromos": [
                    {
                        "minQuantity": 0,
                        "deliveryType": "Transforce"
                    }
                ]
            },
            "transforceDpd": {
                "deliveryPromos": [
                    {
                        "minQuantity": 0,
                        "deliveryType": "DPD"
                    },
                    {
                        "minQuantity": 40,
                        "deliveryType": "DPDFree"
                    }
                ]
            },
            "dpd": {
                "deliveryPromos": [
                    {
                        "minQuantity": 0,
                        "maxQuantity": 32,
                        "deliveryType": "DPDPoint"
                    }
                ]
            },
            "rental": {

            }
        },
        "brx": {
            "transforce": {
                "deliveryPromos": [
                    {
                        "minQuantity": 0,
                        "deliveryType": "Transforce"
                    }
                ]
            },
            "rental": {

            }
        },
        "bow": {
            "transforce": {
                "deliveryPromos": [
                    {
                        "minQuantity": 0,
                        "deliveryType": "TransforceBow"
                    },
                    {
                        "minQuantity": 12,
                        "deliveryType": "TransforceFree"
                    }
                ]
            },
            "rental": {
                "freeItems": [
                    {
                        "name": "objects",
                        "minQuantity": 0,
                        "quantity": 5,
                        "isExtra": true,
                        "customCodeHooks": [
                            "freeDeliverySwitch"
                        ]
                    }
                ]
            }
        }
    },
    "promoIntervals": [
        {
            "start": "2024-02-24",
            "end": "2024-03-10",
            "name": "Congé de détente 2024",
            "languages": [
                "fr"
            ],
            "extension": true,
            "descriptionFr": "Congé de détente 2024: Remise sur les frais de livraison et durée de location plus longue",
            "bannerImgFr": "https://www.lazertag.be/wp-content/uploads/2024/02/conge-de-detente.jpg",
            "promotion": {
                "phoenix": {
                    "transforce": {
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "deliveryType": "Transforce50Discount"
                            }
                        ]
                    },
                    "transforceDpd": {
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "deliveryType": "DPD50Discount"
                            },
                            {
                                "minQuantity": 40,
                                "deliveryType": "DPDFree"
                            }
                        ]
                    },
                    "dpd": {
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "maxQuantity": 32,
                                "deliveryType": "Free"
                            }
                        ]
                    },
                    "rental": {

                    }
                },
                "brx": {
                    "transforce": [
                        {
                            "minQuantity": 0,
                            "deliveryType": "Transforce50Discount"
                        }
                    ],
                    "rental": {

                    }
                },
                "bow": {
                    "transforce": [
                        {
                            "minQuantity": 0,
                            "deliveryType": "Transforce50Discount"
                        },
                        {
                            "minQuantity": 12,
                            "deliveryType": "TransforceFree"
                        }
                    ],
                    "rental": {
                        "freeItems": [
                            {
                                "name": "objects",
                                "minQuantity": 0,
                                "quantity": 5,
                                "isExtra": true,
                                "customCodeHooks": [
                                    "freeDeliverySwitch"
                                ]
                            }
                        ]
                    }
                }
            }
        },
        {
            "start": "1000-03-31",
            "end": "1000-04-30",
            "name": "Example Promo",
            "languages": [
                "nl",
                "fr"
            ],
            "extension": 4,
            "description": "Kerstvakantie promotie : langere verhuurperiode + gratis batterijladers (eventueel gratis levering)",
            "descriptionFr": "Promotion vacances de Noël : durée de location plus longue + chargeurs de batterie gratuits (éventuellement livraison gratuite)",
            "bannerImgNl": "http://zombiezombie.be/wp-content/uploads/2024/02/Sample-Promo-Banner.png",
            "bannerImgFr": "http://zombiezombie.be/wp-content/uploads/2024/02/Sample-Promo-Banner.png",
            "promotion": {
                "phoenix": {
                    "transforce": {
                        "freeItems": [
                            {
                                "name": "charger",
                                "quantity": 1,
                                "isExtra": true,
                                "minQuantity": 16
                            }
                        ],
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "deliveryType": "Transforce50Discount",
                                "customCodeHooks": [
                                    "Custom"
                                ]
                            },
                            {
                                "minQuantity": 40,
                                "deliveryType": "TransforceFree"
                            }
                        ]
                    },
                    "transforceDpd": {
                        "deliveryPromos": [
                            {
                                "minQuantity": 24,
                                "deliveryType": "DPDFree"
                            }
                        ]
                    },
                    "dpd": {
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "maxQuantity": 32,
                                "deliveryType": "free"
                            }
                        ]
                    },
                    "herent": {
                        "freeItems": [
                            {
                                "name": "charger",
                                "quantity": 1,
                                "isExtra": true
                            },
                            {
                                "name": "phoenix",
                                "quantity": 8,
                                "minQuantity": 8,
                                "isExtra": false
                            },
                            {
                                "name": "telescope",
                                "quantity": 999,
                                "isExtra": true,
                                "minQuantity": 32,
                                "customCodeHooks": [
                                    "asManyAsGuns"
                                ]
                            }
                        ]
                    },
                    "rental": {

                    }
                },
                "brx": {
                    "transforce": {
                        "freeItems": [
                            {
                                "name": "charger",
                                "quantity": 1,
                                "isExtra": true,
                                "minQuantity": 3
                            }
                        ],
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "deliveryType": "Transforce50Discount",
                                "customCodeHooks": [
                                    "Custom"
                                ]
                            },
                            {
                                "minQuantity": 16,
                                "deliveryType": "TransforceFree"
                            }
                        ]
                    },
                    "rental": {

                    }
                },
                "bow": {
                    "transforce": {
                        "freeItems": [
                            {
                                "name": "extraArrows",
                                "quantity": 1,
                                "isExtra": true,
                                "minQuantity": 6
                            }
                        ],
                        "deliveryPromos": [
                            {
                                "minQuantity": 0,
                                "deliveryType": "Transforce50Discount",
                                "customCodeHooks": [
                                    "Custom"
                                ]
                            },
                            {
                                "minQuantity": 16,
                                "deliveryType": "TransforceFree"
                            }
                        ]
                    },
                    "rental": {
                        "freeItems": [
                            {
                                "name": "extraArrows",
                                "quantity": 1,
                                "isExtra": true,
                                "minQuantity": 6
                            },
                            {
                                "name": "objects",
                                "minQuantity": 0,
                                "quantity": 5,
                                "isExtra": true,
                                "customCodeHooks": [
                                    "freeDeliverySwitch"
                                ]
                            }
                        ]
                    }
                }
            }
        }
    ],
        "holidayFreeTransforceDeliveryPhoenixQuantity": 40,
            "askGeoConsent": true,
                "FreeDeliveryPagesList": {
        "/test-anton/": [
            "3020",
            "3001",
            "3010",
            "3012",
            "3018",
            "3050",
            "3060"
        ],
            "/lasershooting-leuven/": [
                "3020",
                "3001",
                "3010",
                "3012",
                "3018",
                "3050",
                "3060"
            ],
                "/lasershooting-lier/": [
                    "2500"
                ],
                    "/lasershooting-hasselt/": [
                        "3500",
                        "3501",
                        "3510",
                        "3511",
                        "3512"
                    ],
                        "/lasershooting-mechelen/": [
                            "2800",
                            "2801",
                            "2811",
                            "2812"
                        ],
                            "/lasershooting-kortrijk/": [
                                "8500",
                                "8501",
                                "8510",
                                "8511"
                            ],
                                "/lasershooting-vilvoorde/": [
                                    "1800"
                                ],
                                    "/lasershooting-sint-niklaas/": [
                                        "9100",
                                        "9111",
                                        "9112"
                                    ],
                                        "/lasershooting-geel/": [
                                            "2440"
                                        ],
                                            "/lasershooting-oostende/": [
                                                "8400"
                                            ],
                                                "/lasershooting-roeselare/": [
                                                    "8800"
                                                ],
                                                    "/lasergame-tongeren/": [
                                                        "3700"
                                                    ],
                                                        "/lasershooting-bilzen/": [
                                                            "3730",
                                                            "3690"
                                                        ],
                                                            "/lasershooting-geraardsbergen/": [
                                                                "9500",
                                                                "9506"
                                                            ],
                                                                "/lasershooting-tienen/": [
                                                                    "3300"
                                                                ],
                                                                    "/lasergame-genk/": [
                                                                        "3600",
                                                                        "3690"
                                                                    ],
                                                                        "/lasershooting-oudenaarde/": [
                                                                            "9700"
                                                                        ],
                                                                            "/lasergamen-maastricht/": [
                                                                                "6211SX",
                                                                                "6217KB",
                                                                                "6219NV",
                                                                                "6224GT",
                                                                                "6211AT"
                                                                            ]
    },
    "possibleFreeDeliveryLabel": true,
        "freeZips": [
            "2000",
            "2018",
            "2020",
            "2030",
            "2040",
            "2050",
            "2060",
            "2100",
            "2140",
            "2170",
            "2180",
            "2600",
            "2610",
            "2660",
            "2340",
            "9300",
            "9308",
            "9310",
            "9320",
            "9000",
            "9030",
            "9031",
            "9032",
            "9040",
            "9041",
            "9042",
            "9050",
            "9051",
            "9052",
            "8000",
            "8200",
            "8310",
            "8380",
            "1000",
            "1020",
            "1030",
            "1040",
            "1050",
            "1060",
            "1070",
            "1080",
            "1081",
            "1082",
            "1083",
            "1090",
            "1120",
            "1130",
            "1140",
            "1150",
            "1160",
            "1170",
            "1180",
            "1190",
            "1200",
            "1210"
        ],
            "rentalPointSchedule": {
        "36": [
            2,
            4,
            6
        ],
            "18": [
                1,
                2,
                3,
                4,
                5
            ],
                "17": [
                    1,
                    4
                ],
                    "25": [
                        2,
                        4
                    ],
                        "5": [
                            2,
                            4
                        ],
                            "1": [
                                1,
                                5
                            ],
                                "4": [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ],
                                    "38": [
                                        2,
                                        4
                                    ],
                                        "73": [
                                            3,
                                            6
                                        ]
    },
    "rentalPointData": {
        "38": {
            "image": "https://www.lazertag.be/wp-content/uploads/2022/09/verhuurpunt-Aalst.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2022/09/verhuurpunt-Aalst-Frans.png",
                    "translationKey": "Aalst"
        },
        "36": {
            "image": "https://lazertag.be/wp-content/uploads/2020/02/Nieuwe-Openingsuren-Brugge-dinsdag-donderdag-zaterdag.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-Bruges-lasergame.png",
                    "translationKey": "Brugge"
        },
        "18": {
            "image": "https://lazertag.be/wp-content/uploads/2017/02/Openingsuren-lasergame-beerse.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-beerse-lasergame.png",
                    "translationKey": "Beerse"
        },
        "17": {
            "image": "https://lazertag.be/wp-content/uploads/2017/02/Openingsuren-lasergame-gent-aangepast.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-Gand-lasergame.png",
                    "translationKey": "Ghent"
        },
        "25": {
            "image": "https://www.lazertag.be/wp-content/uploads/2017/02/Openingsuren-lasergame-brussel.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-Bruxelles-lasergame.png",
                    "translationKey": "Brussel"
        },
        "5": {
            "image": "https://lazertag.be/wp-content/uploads/2017/02/Openingsuren-lasergame-Hasselt.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-hasselt-lasergame.png",
                    "translationKey": "Hasselt"
        },
        "1": {
            "image": "https://lazertag.be/wp-content/uploads/2020/03/openingsuren-verhuurpunt-Herent-winter.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-herent-lasergame-1.png",
                    "translationKey": "Herent"
        },
        "4": {
            "image": "https://lazertag.be/wp-content/uploads/2017/04/Openingsuren-lasergame-merksem-2.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2020/03/heures-d-ouverture-merksem-lasergame.png",
                    "translationKey": "Merksem"
        },
        "73": {
            "image": "https://www.lazertag.be/wp-content/uploads/2024/02/Openingsuren-poelkapelle-nl.png",
                "imageFr": "https://www.lazertag.be/wp-content/uploads/2024/02/Openingsuren-poelkapelle-fr.png",
                    "translationKey": "Poelkapelle"
        }
    },
    "holidays": {
        "36": [

        ],
            "18": [
                "2024-05-06",
                "2024-05-07",
                "2024-05-08",
                "2024-05-10",
                "2024-07-11",
                "2024-07-22",
                "2024-07-23",
                "2024-07-24",
                "2024-07-25",
                "2024-07-26",
                "2024-07-29",
                "2024-07-30",
                "2024-07-31",
                "2024-08-01",
                "2024-12-24",
                "2024-12-26",
                "2024-12-31"
            ],
                "17": [

                ],
                    "25": [
                        "2024-12-24",
                        "2024-12-26",
                        "2024-12-31",
                        "2024-07-23",
                        "2024-07-25"
                    ],
                        "5": [
                            "2024-12-24",
                            "2024-12-26",
                            "2024-12-31"
                        ],
                            "1": [
                                "2024-05-10"
                            ],
                                "4": [
                                    "2024-02-13",
                                    "2024-03-08",
                                    "2024-03-11",
                                    "2024-03-12",
                                    "2024-03-13",
                                    "2024-04-02",
                                    "2024-04-03",
                                    "2024-04-05",
                                    "2024-04-10",
                                    "2024-04-12",
                                    "2024-04-15",
                                    "2024-04-25",
                                    "2024-05-06",
                                    "2024-05-07",
                                    "2024-05-10",
                                    "2024-12-24",
                                    "2024-12-26",
                                    "2024-12-31"
                                ],
                                    "38": [
                                        "2024-12-24",
                                        "2024-12-26",
                                        "2024-12-31"
                                    ],
                                        "73": [

                                        ]
    },
    "exceptionallyOpen": {
        "36": [

        ],
            "18": [

            ],
                "17": [
                    "2024-04-02",
                    "2024-05-08",
                    "2024-05-21",
                    "2024-08-16",
                    "2024-11-12"
                ],
                    "25": [

                    ],
                        "5": [

                        ],
                            "1": [
                                "2024-05-08",
                                "2024-05-21"
                            ],
                                "4": [

                                ],
                                    "38": [

                                    ],
                                        "73": [

                                        ]
    },
    "deliveryHolidays": [

    ],
        "globalHolidays": [
            "2024-04-01",
            "2024-05-01",
            "2024-05-09",
            "2024-05-20",
            "2024-08-15",
            "2024-11-01",
            "2024-11-11",
            "2024-12-25"
        ],
            "youthMovementPromotionInterval": [
                {
                    "start": "2023-06-01",
                    "end": "2023-09-01"
                }
            ],
                "phoenixLargeOrderThreshold": 16,
                    "brxLargeOrderThreshold": 10,
                        "bowsLargeOrderThreshold": 12,
                            "youthMinimumQuantity": {
        "phoenix": 8,
            "brx": 5,
                "childBow": 10,
                    "adultBow": 8
    },
    "inflatableObjectsAltImage": "https://www.lazertag.be/wp-content/uploads/2024/03/Opblaasbare-objecten-jongens-en-meisjes-klimmen-er-op.jpg",
        "maxPhoenixDpdQuantity": 32
}
